/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_2Inputs */

const en_svr_guidance_onsite_2 = /** @type {(inputs: Svr_Guidance_Onsite_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the site visit complete, or is a revisit required?`)
};

const ja_svr_guidance_onsite_2 = /** @type {(inputs: Svr_Guidance_Onsite_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訪問は完了しましたか？再訪問は必要ですか？`)
};

const fr_svr_guidance_onsite_2 = /** @type {(inputs: Svr_Guidance_Onsite_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La visite est-elle terminée ou une nouvelle visite est-elle nécessaire ?`)
};

const de_svr_guidance_onsite_2 = /** @type {(inputs: Svr_Guidance_Onsite_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist der Besuch abgeschlossen oder ist ein erneuter Besuch erforderlich?`)
};

/**
* | output |
* | --- |
* | "Is the site visit complete, or is a revisit required?" |
*
* @param {Svr_Guidance_Onsite_2Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_2 = /** @type {((inputs?: Svr_Guidance_Onsite_2Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_2Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_2(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_2(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_2(inputs)
	return de_svr_guidance_onsite_2(inputs)
});